export default __webpack_public_path__ + "de571ff945c3c24f56aca66e243e8dc0.png";